import { render } from "./ModalBlock.vue?vue&type=template&id=63edf854"
import script from "./ModalBlock.vue?vue&type=script&lang=js"
export * from "./ModalBlock.vue?vue&type=script&lang=js"
script.render = render

export default script